module.exports = __webpack_public_path__ + "img/quiz-skate-1.816855eb.jpg";